import mixpanel from "mixpanel-browser";
import {
  CURRENT_USER,
  LF_DEBUGGER,
  LF_DEBUGGER_HUBSPOT,
  LF_DEBUGGER_MIXPANEL_TRACKING,
} from "../Helpers/constants";

const RESTRICTED_EMAIL_DOMAIN = [
  "imagine.io",
  "livefurnish.com",
  "taglineinfotech.com",
  "algoworks.com",
];
const isDebugTrackingEnabled = () =>
  localStorage.getItem(LF_DEBUGGER_MIXPANEL_TRACKING) === "true";

const logMixPanel = isDebugTrackingEnabled() ? true : false;

const CURRENT_URL = window.location.href;
const isProductionUrl = CURRENT_URL.includes("//labs.imagine.io");

const shouldTrackUser = () => {
  const getLoggedinUserEmail = () =>
    localStorage.getItem(CURRENT_USER)
      ? JSON.parse(localStorage.getItem(CURRENT_USER))?.user?.email
      : null;

  const trackAllowedEmailDomains = !RESTRICTED_EMAIL_DOMAIN.some((domain) =>
    getLoggedinUserEmail()?.includes(domain)
  );

  const _shouldTrackUser =
    (isProductionUrl &&
      !isDebugTrackingEnabled() &&
      trackAllowedEmailDomains) ||
    isDebugTrackingEnabled();

  LogMixPanel("DEBUG___DEBUGGER_EMAIL", {
    getLoggedinUserEmail: getLoggedinUserEmail(),
    shouldTrackUser: _shouldTrackUser,
    Mixpanel,
    isProductionUrl,
    isDebugTrackingEnabled: isDebugTrackingEnabled(),
    trackAllowedEmailDomains,
    logMixPanel,
  });
  window.DEBUG___DEBUGGER_EMAIL = {
    getLoggedinUserEmail: getLoggedinUserEmail(),
    shouldTrackUser: _shouldTrackUser,
    Mixpanel,
    isProductionUrl,
    isDebugTrackingEnabled: isDebugTrackingEnabled(),
    trackAllowedEmailDomains,
    logMixPanel,
  };

  return _shouldTrackUser;
};

async function initializeMixpanel() {
    return new Promise((resolve, reject) => {
      const param = new URLSearchParams(window.location.search);
      const debuggerValue = param.get(LF_DEBUGGER);

      switch (debuggerValue) {
        case "1":
          // enable debugging
          localStorage.setItem(LF_DEBUGGER_HUBSPOT, true);
          localStorage.setItem(LF_DEBUGGER_MIXPANEL_TRACKING, true);
          LogMixPanel("DEBUGGING MODE ENABLED");
          resolve();
          break;
        case "2":
          // disable debugging
          localStorage.removeItem(LF_DEBUGGER_HUBSPOT);
          localStorage.removeItem(LF_DEBUGGER_MIXPANEL_TRACKING);
          LogMixPanel("DEBUGGING MODE DISABLED");
          resolve();
          break;
        default:
          resolve();
          break;
      }

      param.delete(LF_DEBUGGER);
      window.history.replaceState(null, null, `?${param.toString()}`);
    });
}

initializeMixpanel()
  .then(() => {
    if (isProductionUrl && shouldTrackUser()) {
      LogMixPanel("DEBUG__mx: ", "environment = production");
      mixpanel.init("847293cb6f5507d5d4e171f17273eb4b");
    } else if (shouldTrackUser()) {
      LogMixPanel("DEBUG__mx: ", "environment = staging");
      mixpanel.init("74533e85844ead6a5ef381d6198530ce");
    } else {
      LogMixPanel("DEBUG__mx: ", "Mixpanel initialization failed.");
    }
  })
  .catch((error) => {
    // Handle error during Mixpanel initialization
    console.error(error);
  });

//Check to see what mixpanel project to use based if the app is on production.
// if (window.location.href) {
//   if (logMixPanel) {
//     console.log("mx: ", "enviroment = production");
//   }
//   mixpanel.init("847293cb6f5507d5d4e171f17273eb4b");
// } else {
//   if (logMixPanel) {
//     console.log("mx: ", "enviroment = dev");
//   }
//   mixpanel.init("74533e85844ead6a5ef381d6198530ce", { debug: true });
// }

export function LogMixPanel(value, payload) {
  if (logMixPanel) {
    console.log("mx: ", value, payload);
  }
}

function getDefaultDetails() {
  const user = localStorage.getItem(CURRENT_USER) || null;
  if (!user) return {};
  const currentUser = JSON.parse(user);
  const defaultDetails = {
    "Event origin page": window?.location?.pathname,
    distinct_id: currentUser?.user?.id,
    $email: currentUser?.user?.email,
    $first_name: currentUser?.user?.first_name,
    $last_name: currentUser?.user?.last_name,
    "Full name": currentUser?.user?.name,
    "Current org id": currentUser?.organization_detail?.id,
    "Current org name": currentUser?.organization_detail?.name,
  };

  return defaultDetails;
}

const defaultProperties = {
  "Module Id": "imagine_ai",
  "Module Name": "imagine AI",
};

export const Mixpanel = {
  identify: (id) => {
    if (shouldTrackUser()) mixpanel.identify(id);
  },
  alias: (id) => {
    if (shouldTrackUser()) mixpanel.alias(id);
  },
  track: ({ useDefault = true, eventName = null, properties = {} }) => {
    if (!shouldTrackUser()) return;
    const user = localStorage.getItem(CURRENT_USER) || null;
    if (!user || !eventName) return;
    let defaultDetails = {};
    if (useDefault) {
      defaultDetails = getDefaultDetails();
    }
    const payload = { ...defaultProperties, ...properties, ...defaultDetails };
    mixpanel.track(eventName, payload);
    LogMixPanel(eventName, payload);
  },
  people: {
    set: (props) => {
      if (shouldTrackUser()) mixpanel.people.set(props);
    },
  },
  reset: () => {
    if (shouldTrackUser()) mixpanel.reset();
  },
  register: () => {
    if (shouldTrackUser()) mixpanel.register();
  },
};

export const MxEvent = {
  VISITED_HOME: "Visited - imagine.io AI | Home",
  VISITED_AI_TOOL_PAGE: "Visited - AI tool page",

  CLICKED_CREATE_OR_UPLOAD_PRODUCT: "Clicked - Create or Upload Product",
  CLICKED_GENERATE_IMAGE: "Clicked - Generate Image",
  CLICKED_DOWNLOAD: "Clicked - Download",
  CLICKED_IMAGE_RESET: "Clicked - Image Reset",

  CLICKED_CLEAR_BACKGROUND: "Clicked - Clear Background",
  CLEAR_BACKGROUND_FAILED: "Clear Background - Failed",
  CLEAR_BACKGROUND_SUCCESS: "Clear Background - Success",

  DOWNLOAD_STANDARD_IMAGE: "Download - Standard Image",
  DOWNLOAD_UPSCALED_IMAGE: "Download - Upscaled Image",

  IMAGE_RESET: "Image Reset",
  IMAGE_CREATED_FAILED: "Image Created - Failed",
  IMAGE_CREATED_SUCCESS: "Image Created - Success",

  CHANGED_RESOLUTION: "Changed - Resolution",

  CLICKED_TRANSFORMATION_RESET: "Clicked - Transformation Reset",
  CHANGED_SCALE: "Changed - Scale",

  CLICKED_GENERATE_MAGIC_TOOL: "Clicked - Magic Tool Generate",
  MAGIC_TOOL_FAILED: "Magic Tool Image Created - Failed",
  MAGIC_TOOL_SUCCESS: "Magic Tool Image Created - Success",

  DOWNLOAD_MAGIC_TOOL_STANDARD_IMAGE: "Magic Tool Image Download - Standard Image",
  DOWNLOAD_MAGIC_TOOL_UPSCALED_IMAGE: "Magic Tool Image Download - Upscaled Image",

  CLICKED_TOOL_SIZE_BUTTON : "Clicked - Magic Tool size",
  CLICKED_ERASER_BUTTON : "Clicked - Eraser brush",
  CLICKED_BRUSH_BUTTON : "Clicked - Select brush tool",
  CLICKED_RESET_BUTTON : "Clicked - Clear drawn area",
  CHANGE_IMAGE : "Changed Magic tool input image",
  CLICKED_USE_GENERATED_IMAGE : "Clicked - Use generated image as input image",
  CLICKED_MAGIC_TOOL_IMAGE_DOWNLOAD : "Clicked - Download magic tool generated image",
  CLICKED_CLOSE_GENERATED_IMAGE : "Clicked - Close magic tool generated image",
};